module.exports = __webpack_public_path__ + "img/뱃컨유럽형3.4b4ba459.png";